import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import stl from "./SearchHeader.module.css";
import UnbxdMobileTextSearch from "../../UnbxdTextSearch/UnbxdMobileTextSearch/UnbxdMobileTextSearch";
import useHelpers from "@hooks/useHelpers";
var SearchHeader = function SearchHeader() {
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement("header", {
    className: [stl.wrapper, "m-show"].join(" ")
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/")
  }, /*#__PURE__*/React.createElement("img", {
    width: 57,
    height: 26,
    src: CDN_LINK + "/assets/images/logoN.svg",
    alt: "Syarah logo"
  })), /*#__PURE__*/React.createElement(UnbxdMobileTextSearch, {
    referral_location: "listing"
  }));
};
export default SearchHeader;